import { twMerge } from "tailwind-merge";

interface ARCNameProps {
    serialNumber: string;
    name?: string;
    className?: string;
    nameClassName?: string;
}

/** Plain-text label for places that can't render two lines (tooltips, map labels). */
export const arcLabel = ({ serialNumber, name }: { serialNumber: string; name?: string }) =>
    name && name !== serialNumber ? `${name} (${serialNumber})` : serialNumber;

/** ARC name with its serial in small grey text underneath; serial is omitted when it equals the name. */
const ARCName = ({ serialNumber, name, className = "", nameClassName = "" }: ARCNameProps) => {
    const displayName = name || serialNumber;
    return (
        <div className={twMerge("flex min-w-0 flex-col", className)}>
            <span className={twMerge("truncate", nameClassName)} title={displayName}>
                {displayName}
            </span>
            {displayName !== serialNumber && (
                <span className="truncate text-h5 leading-tight text-black40" title={serialNumber}>
                    {serialNumber}
                </span>
            )}
        </div>
    );
};

export default ARCName;
